import * as React from 'react';
import { observer } from 'mobx-react';

import { DataTableView, Column, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { CardController } from 'src/app/shared/card.controller';
import { MarketEditorController } from 'src/app/general/market/parts/market-editor.controller';

interface Props extends ComponentViewProps<DataSet<AgentMarketItem>> {
	onCreateAgentMarket: () => Promise<AgentMarketItem>;
	mode: ControlMode;
}

@observer
export class AgentMarketView extends React.Component<Props, {}> {
	constructor(props: Readonly<Props>) {
		super(props);
	}

	columns: Column[] = [
		{
			key: 'marketName',
			dataIndex: 'marketName',
			title: 'Name',
			editable: (text: string, record: AgentMarketItem, index: number, isSelected: boolean) => {
				if (isSelected) {
					return (
						<MarketEditorController
							required
							label={null}
							mode={this.props.mode}
							setBusy={this.props.setBusy}
							value={record.marketId}
							onChanged={(item) => {
								record.marketId = item.id;
								record.marketName = item.name;
							}}
						/>
					);
				}

				return <span>{record.marketName}</span>;
			}
		}
	];

	render() {
		const { model, onCreateAgentMarket, mode, setBusy } = this.props;
		if (model == null) {
			return null;
		}

		return (
			<CardController
				title="Markets"
				icon="shop"
				className="card-borderless"
				mode={this.props.mode}>
				<DataTableView
					model={model}
					mode={mode}
					setBusy={setBusy}
					columns={this.columns}
					createNewItem={onCreateAgentMarket}
					hideToolbar={ToolbarVisibility.hideSearch | ToolbarVisibility.hidePagination}
				/>
			</CardController>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/agent-markets/agent-market.view.tsx